import { authFetch } from "utils";

export const getPortfolios = () =>
  authFetch(`${apiUrl}${version}/portfolios`, {
    method: "GET",
  });

export const requestAccess = (portfolioID) =>
  authFetch(`${apiUrl}${version}/portfolios/${portfolioID}/request_access`, {
    method: "GET",
  });

export const create = (portfolio) =>
  authFetch(`${apiUrl}${version}/portfolios`, {
    method: "POST",
    json: portfolio,
  });

export const update = (portfolio) =>
  authFetch(`${apiUrl}${version}/portfolios/${portfolio.id}`, {
    method: "PATCH",
    json: portfolio,
  });

export const destroy = (portfolioID, transferID) => {
  const url = transferID
    ? `${apiUrl}${version}/portfolios/${portfolioID}?transfer_id=${transferID}`
    : `${apiUrl}${version}/portfolios/${portfolioID}`;

  return authFetch(url, { method: "DELETE" });
};
